<template>
  <section
    :style="{backgroundImage: `url(${image})`}"
    class="c-cbr-Hero c-cbr-Hero-outer">
    <slot>
      <span
        :style="{
          backgroundColor: 'rgba(255, 255, 255, 0.2)'
        }"
        class="c-cbr-Hero-param-wrapper"
      >
        <h1
          :style="{color: heroTextColor}"
          class="c-cbr-Hero-param">
          {{ $t('hero.headline_whitelabel',
                {
                  customer: brandName,
                  // prevent escaping of the company name
                  interpolation: {
                    escapeValue: false
                  }
                }
          ) }}
        </h1>

        <h2
          :style="{color: heroTextColor}"
          class="c-cbr-Hero-param"
        >{{ $t('hero.subheadline_whitelabel') }}</h2>
      </span>
    </slot>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    image: {
      type: String,
      required: true
    }
  },

  computed: {
    ...mapGetters('config', ['brandName', 'heroTextColor'])
  },

}
</script>




// WEBPACK FOOTER //
// client/components/CbrHero.vue